import React from "react";

const Logo = (props) => {
  return (
    <>
      <img
        src="/images/meta_logo.png"
        alt="Logo"
        {...props}
        style={{ width: "170px" }}
      />
    </>
  );
};

export default Logo;
